import React from "react";
import { Redirect, Route } from "react-router-dom";
import { firstAllowedPath } from "../components/layout/menu";
import { can } from "../utils/roles";

/**
 * Page of the back-office: needs a token and the `level` ("view" by default,
 * "edit") on one of `section` (a section key or a list). Without a section,
 * any logged-in admin can open it. A refused page leads to the first page the
 * admin can open.
 */
const PrivateRoute = ({ component: Component, section, level = "view", ...rest }) => (
  <Route
    {...rest}
    render={(props) => {
      if (!localStorage.getItem("token")) {
        return <Redirect to={{ pathname: "/", state: { from: props.location } }} />;
      }
      const sections = section ? [].concat(section) : [];
      const allowed = !sections.length || sections.some((key) => can(key, level));
      if (allowed) return <Component {...props} />;
      const fallback = firstAllowedPath(can);
      return (
        <Redirect
          to={fallback === props.location.pathname ? "/dashboard/profile" : fallback}
        />
      );
    }}
  />
);

export default PrivateRoute;
